import React from 'react';

const SvgLanguage = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M4.002 3c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h14l4 4-.012-18.002a2.002 2.002 0 00-2-1.998H4.002zm0 2h15.99l.006 13.17L18.83 17H4.002V5zM15.41 6.014v1.025H13v1.313h4.715c0 2.53-2.09 4.07-2.09 4.07s-1.42-.794-1.42-2.402H13c0 1.968 1.26 2.933 1.26 2.933s-.557.703-1.26.703V15c1.374 0 2.57-1.11 2.57-1.11S16.43 15 18.01 15v-1.344c-.596 0-.94-.674-.94-.674S19 11.21 19 8.352V7.039h-2.41V6.014h-1.18zM7.79 7L5 15h1.64l.52-1.656h2.682L10.359 15H12L9.21 7H7.79zm.71 2.031l.93 3H7.57l.93-3z" />
  </svg>
);

export default SvgLanguage;
